import React, { Component, useState, useEffect } from "react";
import Menu from "../Menu";
import Header from "../Header";
import Footer from "../Footer";
import { Space, Table, Form, Select, Input, Typography } from "antd";
import { ApiGateWay } from "../../ApiGateWay/ApiGateWay";
import Spinner from "../../UIComponents/Spinner/Spinner";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { useLocation } from "react-router-dom";
import { QuotationItemDetails } from "./actions/QuotationServices";
import Modal from "antd/lib/modal/Modal";
import { Button } from "antd";
const { Text } = Typography;
const { Option } = Select;

const ViewQuotation = (props) => {
  const title = "View Quotation";
  const QuotationTableColumns = [
    {
      title: "Item Name",
      dataIndex: "item_name",
      key: "item_name",
    },
    {
      title: "Brand/Make",
      dataIndex: "item_brand",
      key: "item_brand",
    },
    {
      title: "Capacity",
      dataIndex: "item_capacity",
      key: "item_capacity",
    },
    {
      title: "Quantity",
      dataIndex: "item_quantity",
      key: "item_quantity",
    },
    {
      title: "Cost",
      dataIndex: "item_price",
      key: "item_price",
    },
    {
      title: "GST",
      dataIndex: "item_gst",
      key: "item_gst",
    },
    {
      title: "Total",
      dataIndex: "item_sub_total",
      key: "item_sub_total",
    },
  ];
  const HistoryTableColumns = [
    {
      title: "Modified Date",
      dataIndex: "created_on",
      key: "created_on",
    },
    {
      title: "Item Name",
      dataIndex: "item_name",
      key: "item_name",
    },
    {
      title: "Brand/Make",
      dataIndex: "item_brand",
      key: "item_brand",
    },
    {
      title: "Capacity",
      dataIndex: "item_capacity",
      key: "item_capacity",
    },
    {
      title: "Quantity",
      dataIndex: "item_quantity",
      key: "item_quantity",
    },
    {
      title: "Cost",
      dataIndex: "item_price",
      key: "item_price",
    },
    {
      title: "GST",
      dataIndex: "item_gst",
      key: "item_gst",
    },
    {
      title: "Total",
      dataIndex: "item_sub_total",
      key: "item_sub_total",
    },
  ];
  const QuotationTableData = [
    {
      ItemName: "Screw Compressor",
      Brand_Make: "ELGI",
      Capacity: "500 HP",
      Quantity: "1",
      Cost: "700",
      GST: "18%",
      Total: "826",
    },
    {
      ItemName: "Compressors Oil",
      Brand_Make: "GRADIENT",
      Capacity: "500 HP",
      Quantity: "1",
      Cost: "2850",
      GST: "18%",
      Total: "3363",
    },
  ];
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  // const QuotationDetails = useSelector(state=>state?.QuotationInfo?.QuotationDetailsData)
  const SelectedData = useSelector(
    (state) => state?.WorkOrderStore?.SelectedData
  );
  const QuotationDetailsData = useSelector(
    (state) => state?.QuotationInfo?.QuotationDetailsData?.QuotationDetails
  );
  const QuotationHistory = useSelector(
    (state) => state?.QuotationInfo?.QuotationDetailsData?.QuotationHistory
  );
  const vendorComments = useSelector(
    (state) => state?.QuotationInfo?.QuotationDetailsData?.vendorCommentsTable
  );
  // console.log(QuotationDetailsData, "QuotationDetailsData");
  const [Loading, setLoading] = useState(false);
  const [ModalOpen, setModalOpen] = useState(false);
  const [Message, setMessage] = useState(false);
  const [isViewHistory, setIsViewHistory] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [historyTotalSum, setHistoryTotalSum] = useState(0);
  useEffect(() => {
    // debugger;
    // if (typeof SelectedData == "undefined") {
    //   navigate({
    //     pathname: location.state.fromAddress,
    //     state: { selectedStoreId: location.state.selectedId, selectedCityIds:location.state?.selectedCityIds },
    //   });
    // }
    _doGetViewQuotationList();
    dispatch(QuotationItemDetails(SelectedData?.work_request_id));
  }, []);

  useEffect(() => {
    let sum = 0;
    for (let i = 0; i < QuotationDetailsData?.length; i++) {
      sum = sum + Number(QuotationDetailsData[i]?.item_sub_total);
    }
    setTotalSum(sum);
  }, [QuotationDetailsData]);
  useEffect(() => {
    let sum = 0;
    for (let i = 0; i < QuotationHistory?.length; i++) {
      sum = sum + Number(QuotationHistory[i]?.item_sub_total);
    }
    setHistoryTotalSum(sum);
  }, [QuotationHistory]);

  const _doGetViewQuotationList = () => {
    setLoading(true);
    setModalOpen(false);
    setMessage("");
    setTimeout(function () {
      setLoading(false);
    }, 300);
  };
  const _doNavToQuotationVendor = () => {
    props.CloseViewQuotation();
    // navigate({
    //   pathname: location.state.fromAddress,
    //   state: { selectedStoreId: location.state.selectedId, selectedCityIds:location.state.selectedCityIds },
    // });
  };
  // console.log(location);
  const handleCloseViewHistory = () => {
    setIsModalVisible(false);
    setIsViewHistory(false);
  };
  const handleOpenViewHistory = () => {
    setIsModalVisible(true);
    setIsViewHistory(true);
  };
  return (
    <div>
      <div className="wrapper">
        <Header title={title} />
        <Menu />
        <div className="content-wrapper">
          {Loading ? (
            <Spinner />
          ) : (
            <div>
              <section className="content">
                <div className="row ml-3">
                  <div className="m-panel mt-10">
                    <div className="m-panel__body p10">
                      <button
                        className="btn btn-secondary deca-btn-yellow mb-12"
                        onClick={handleOpenViewHistory}
                      >
                        View History
                      </button>
                    </div>
                  </div>
                </div>
                <div className="m-panel mt-10">
                  <div className="m-panel__body p10">
                    <div className="m-table__main">
                      <div className="m-table__responsive medium-width">
                        <Table
                          filterSearch="true"
                          columns={QuotationTableColumns}
                          dataSource={QuotationDetailsData}
                          summary={(pageData) => {
                            return (
                              <>
                                <Table.Summary.Row>
                                  <Table.Summary.Cell
                                    colSpan={6}
                                    className="text-right"
                                  >
                                    Total
                                  </Table.Summary.Cell>
                                  <Table.Summary.Cell>
                                    <Text strong="true">{totalSum}</Text>
                                  </Table.Summary.Cell>
                                </Table.Summary.Row>
                              </>
                            );
                          }}
                        />
                      </div>
                      <div className="row" style={{ marginTop: 10 }}>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label className="custom-label">
                              Vendor Comments
                            </label>
                            <textarea
                              className="form-control vendor-comments"
                              value={
                                vendorComments
                                  ? vendorComments[0]?.vendor_comments
                                  : ""
                              }
                              disabled
                              placeholder="comments..."
                              // onChange={e => this.setState({vendorComments:e.target.value.replace(/[^\w\s]/gi, "")})}
                            />
                            {/* {(this.state.isTechnicianSelected && (!this.state.vendorComments || this.state.vendorComments.length<10)) &&<p className='text-danger'>Please enter comments</p>} */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12 text-right">
                    <div className="m-page__button top-space">
                      <button
                        type="button"
                        onClick={_doNavToQuotationVendor}
                        className="btn muted-button  deca-btn-orange"
                      >
                        Back
                      </button>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          )}
          ;
        </div>
        <Footer />
      </div>
      {isViewHistory && (
        <Modal
          title="View History Report"
          width={1000}
          closeIcon
          open={isModalVisible}
          footer={[
            <Button key="back" onClick={handleCloseViewHistory}>
              Cancel
            </Button>,
          ]}
        >
          <div className="m-panel mt-10">
            <div className="m-panel__body p10">
              <div className="m-table__main">
                <div className="m-table__responsive medium-width">
                  <Table
                    filterSearch="true"
                    columns={HistoryTableColumns}
                    dataSource={QuotationHistory}
                    summary={(pageData) => {
                      return (
                        <>
                          <Table.Summary.Row>
                            <Table.Summary.Cell
                              colSpan={7}
                              className="text-right"
                            >
                              Total
                            </Table.Summary.Cell>
                            <Table.Summary.Cell>
                              <Text strong="true">{historyTotalSum}</Text>
                            </Table.Summary.Cell>
                          </Table.Summary.Row>
                        </>
                      );
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};
export default ViewQuotation;